import { Button, Menu, MenuItem, styled, Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useQuotationActionsDialog from '../../../hooks/dialogs/useQuotationActionsDialog';
import {
    DialogType,
    QuotationType,
} from '../../../redux/slices/quotationActionsDialogSlice';
import { CartEdge } from '../../../models/Cart';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import HandshakeIcon from '@mui/icons-material/Handshake';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

const StyledButton = styled(Button)(() => ({
    width: '100%',
    color: '#007CB0',
    backgroundColor: 'transparent',
    border: '1px solid #007CB0',
    ':hover': {
        backgroundColor: '#007CB0',
        color: '#FFF',
    },
}));

export const CartActions: React.FC<{
    products: CartEdge[];
    disabled: boolean;
}> = (props) => {
    const { products } = props;
    const { t } = useTranslation('cart', {
        keyPrefix: 'CART.CART_ACTIONS',
    });

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);
    const [selectedAction, setSelectedAction] = useState<QuotationType>(null);
    const quotationActionsDialog = useQuotationActionsDialog();

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedAction(null);
    };

    const handleClick = (
        event: React.MouseEvent<HTMLButtonElement>,
        actionType: QuotationType
    ) => {
        setAnchorEl(event.currentTarget);
        setSelectedAction(actionType);
    };

    const openDialog = (
        dialogType: DialogType,
        dialogTitle: string,
        selectedActionType: QuotationType
    ) => {
        quotationActionsDialog.showDialog(
            true,
            dialogType,
            selectedActionType,
            products,
            dialogTitle
        );
        setAnchorEl(null);
    };

    const handleGetQuotationClick = () => {
        openDialog('createNew', 'CREATE_NEW_TITLE', 'request');
    };

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <StyledButton
                    // onClick={(event) => handleClick(event, 'request')}
                    onClick={handleGetQuotationClick}
                    disabled={products.length == 0 || props.disabled}
                    sx={{ marginRight: '2px' }}
                >
                    <RecordVoiceOverIcon
                        fontSize="inherit"
                        sx={{ marginRight: '5px' }}
                    />
                    {t('REQUEST_QUOTATION')}
                </StyledButton>
                <StyledButton
                    onClick={(event) => handleClick(event, 'add')}
                    disabled={products.length == 0 || props.disabled}
                    sx={{ marginLeft: '2px' }}
                >
                    <RequestQuoteIcon
                        fontSize="inherit"
                        sx={{ marginRight: '5px' }}
                    />
                    {t('ADD_QUOTATION')}
                </StyledButton>
            </Box>

            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <MenuItem
                    onClick={() =>
                        openDialog(
                            'addExist',
                            'ADD_EXIST_TITLE',
                            selectedAction
                        )
                    }
                >
                    {t('ADD_TO_EXIST')}
                </MenuItem>
                <MenuItem
                    onClick={() =>
                        openDialog(
                            'createNew',
                            'CREATE_NEW_TITLE',
                            selectedAction
                        )
                    }
                >
                    {t('CREATE_NEW')}
                </MenuItem>
            </Menu>
            {/*<StyledButton*/}
            {/*    onClick={() =>*/}
            {/*        openDialog('saveCart', 'SAVE_CART_TITLE', selectedAction)*/}
            {/*    }*/}
            {/*    disabled={products.length == 0}*/}
            {/*>*/}
            {/*    {t('SAVE_CART')}*/}
            {/*</StyledButton>*/}
        </>
    );
};
